<nb-auth-block>
    <h2 class="title">Recupero password</h2>
    <small class="form-text sub-title">Inserisci il tuo codice fiscale e la mail abbinata all'account, riceverai un'email con il link per il recupero password</small>
    <form
        (ngSubmit)="requestNewPassword($event)"
        #requestPassForm="ngForm"
    >
        <div
            *ngIf="email.invalid && email.touched"
            class="alert alert-danger"
            role="alert"
        >
            <div>
                <strong>Email non valida</strong>
            </div>
        </div>
        <div
            *ngIf="success"
            class="alert alert-success"
            role="alert"
        >
            <div>
                <strong>Email inviata</strong>
            </div>
        </div>

        <div
            class="form-group"
            *ngIf="!is_admin"
        >
            <label
                for="input-username"
                class="sr-only"
            >Codice Fiscale</label>
            <input
                name="username"
                [(ngModel)]="username"
                id="input-username"
                class="form-control"
                placeholder="Codice fiscale"
                [required]="true"
                autofocus
            >
        </div>

        <div class="form-group">
            <label
                for="input-email"
                class="sr-only"
            >Email</label>
            <input
                name="email"
                [(ngModel)]="user_email"
                id="input-email"
                #email="ngModel"
                class="form-control"
                placeholder="Indirizzo email"
                pattern=".+@.+..+"
                [class.form-control-danger]="email.invalid && email.touched"
                [required]="true"
                autofocus
            >
        </div>
        <button
            [nbSpinner]="loading"
            [disabled]="loading || !requestPassForm.form.valid"
            nbButton
            class="btn-block"
        > Richiedi password </button>

    </form>
    <button
        nbButton
        status="warning"
        class="mt-4"
        (click)="goBackToLogin()"
    > Torna al login </button>

</nb-auth-block>
